Object.defineProperty(Array.prototype, 'removeDuplicates', {
	value: function <T>(): T[] {
		return [...new Set<T>(this)];
	},
	enumerable: false, // Key fix: makes the property non-enumerable
	writable: true,
	configurable: true,
});

Object.defineProperty(Array.prototype, 'moveBefore', {
	value: function <T>(item: T, beforeItem: (item: T) => boolean): void {
		const index = this.findIndex(beforeItem);
		if (index > -1) {
			const itemIndex = this.findIndex(i => i === item);
			if (itemIndex > -1) {
				this.splice(itemIndex, 1);
				this.splice(index, 0, item);
			}
		}
	},
	enumerable: false, // Key fix: makes the property non-enumerable
	writable: true,
	configurable: true,
});

export {};
